import { fluidType } from 'Shared/common/FluidType';
import { sanitise } from 'Shared/common/Sanitise';


/* XXX THOUGHTS:

	Can subtype with eg 'drummerText' etc
	MAY be necessary to merge in fonts... 
		There is likely to be some interaction between fonts and the text sizing.
		Possibly some dependence on the smaller scale layout, and maybe even palettes too.
*/

export function standardText(sizes,fonts)  
{
	return {
		pageTitle: {
			...sanitise.heading,
			fontFamily: fonts.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.minDesktopWidth,40,60),
			textAlign: 'center',
			margin: '32px 0 24px 0',
		},
		teaser: {
			...sanitise.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.flipToMobileNav,19,25),
		},
		title: {
			...sanitise.heading,
			fontFamily: fonts.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.flipToMobileNav,35,45),
		},
		tagline: {
			...sanitise.heading,
			fontFamily: fonts.text
		},
		subtitle: {
			...sanitise.heading,
			fontFamily: fonts.heading,
			fontSize: fluidType('px',sizes.endFontShrink,sizes.flipToMobileNav,20,30),
		},

		paragraphTitle: {
			...sanitise.heading,
			fontFamily: fonts.text,
			fontWeight: 700,
    		margin: '2em 0 1em 0',
		    lineHeight: 1.3,
			/* A font size is needed to override the browser stylesheets for h1...h6 */
			fontSize: '1em'
		},

		/* Body text where it is asked for - a Plain text widget, an event's description, a menu's
		   details. The page's own inherited text is page().root's 16px in the venue's body face, not
		   this; keep it a complete text style all the same, since nothing above it now carries a size
		   or a line height. */
		plain: {
			fontFamily: fonts.text,
			fontSize: 15,
			lineHeight: 1.5,
		}
	}
}

